import jwtDecode from "jwt-decode";
import moment from 'moment';

export function extractUserRole (token) {
    try {
        if (token) {
            const decodedToken = jwtDecode(token)
            if (!decodedToken || !decodedToken.authorities || !decodedToken.authorities[0]) return null
            return decodedToken.authorities[0].authority
        }
        return null
    } catch (error) {
        return null;
    }
}

export function extractExpirationTime (token) {
    try {
        if (token) {
            const decodedToken = jwtDecode(token)
            if (!decodedToken) return null
            return decodedToken.exp
        }
        return null
    } catch (error) {
        return null;
    }
}

export function extractUserId (token) {
    try {
        if (token) {
            const decodedToken = jwtDecode(token)
            if (!decodedToken) return null
            return decodedToken.userId
        }
        return null
    } catch (error) {
        return null;
    }
}

export function getTokenFromLocalStorage() {
    try {
        return localStorage.getItem("token")
    } catch(error) {
        return null
    }
}

export async function addAuthorizationToHeaders(headers) {
    const token = getTokenFromLocalStorage()
    if (token) {
        headers['Authorization'] = `Bearer ${token}`
    }
    return headers
}

export function getImageUrl(imageName) {
    return process.env.REACT_APP_HISTORIOGRAFIJA_FRONTEND + 'assets/img/' + imageName
}

export function getThumbnailImageUrl(imageName) {
    return process.env.REACT_APP_HISTORIOGRAFIJA_FRONTEND + 'assets/img/thumbnails/' + imageName
}

export function removeWhitespaces(str) {
    return str ? str.replaceAll(/\s+/g, "") : str
}

function getNumberOfYearsPassedFrom2021() {
    const now = new Date().getFullYear()
    const fixedDate = new Date('2021-03-28T22:00:00.000Z').getFullYear()
    return now - fixedDate
}

export function formatDate(dateString) {
    if (!dateString) {
        const numberOfYearsPassed = getNumberOfYearsPassedFrom2021()
        return 'prije više od ' + numberOfYearsPassed + (numberOfYearsPassed > 4 ? ' godina' : ' godine')
    }
    // Parse the date
    const date = moment(dateString);
    // Check if the date is valid
    if (!date.isValid()) {
        return 'Invalid date';
    }
    // Format the date to dd.MM.YYYY
    return date.format('DD.MM.YYYY');
}

export function formatDateWithTime(date) {
    if (!date) {
        const numberOfYearsPassed = getNumberOfYearsPassedFrom2021()
        return 'prije više od ' + numberOfYearsPassed + (numberOfYearsPassed > 4 ? ' godina' : ' godine')
    }
    const newDate = moment(date);
    if (!newDate.isValid()) {
        return 'Invalid date';
    }
    return newDate.format('DD.MM.YYYY, HH:mm');
}

export function addThreeDots(text) {
    if (!text || text.length === 0) return '...'
    const lastCharacter = text.slice(-1)
    if (lastCharacter === '.') {
        return text + '..'
    }
    return text + '...'
}

/** Form validation functions */
export function containsOnlyLettersNumbersAndUnderscore(value) {
    return Boolean(value.match(/^[A-Za-z0-9_]*$/))
}

export function containsANumberAndUppercaseLetter(value) {
    return Boolean(value.match(/[A-Z]/) && value.match(/[0-9]/))
}

export function containsOnlyLettersNumbersHyphenAndSlash (value) {
    return Boolean(value.match(/^[A-Za-z0-9-/]*$/))
}

function replaceAllSpecialCharacters(value) {
    let cleanedValue = value.replaceAll('č', 'c');
    cleanedValue = cleanedValue.replaceAll('ć', 'c');
    cleanedValue = cleanedValue.replaceAll('dž', 'dz');
    cleanedValue = cleanedValue.replaceAll('đ', 'dj');
    cleanedValue = cleanedValue.replaceAll('š', 's');
    cleanedValue = cleanedValue.replaceAll('ž', 'z');
    cleanedValue = cleanedValue.replaceAll('ü', 'u');
    cleanedValue = cleanedValue.replaceAll('ö', 'o');
    cleanedValue = cleanedValue.replaceAll('ä', 'a');
    return cleanedValue
}

function replaceAllCharactersWithHyphen(value) {
    let cleanedValue = value.replaceAll(' ', '-');
    cleanedValue = cleanedValue.replaceAll('-–', '-');
    cleanedValue = cleanedValue.replaceAll('--', '-');
    cleanedValue = cleanedValue.replaceAll('---', '-');
    cleanedValue = cleanedValue.replaceAll('/', '-');
    return cleanedValue
}

function removeMultipliedCharacters(value) {
    return value.replaceAll('.', '').replaceAll('--', '-')
}

export function generateArticleUrl(title, categoryName, subcategoryName) {
    if (title && categoryName) {
        let cleanedTitle = title.toLowerCase()
    
        // Remove characters such as dots, commas, and other characters
        cleanedTitle = cleanedTitle.replaceAll(/[,.?!„“”":;&()#_]/g, '')

        // replaceAll some special characters
        cleanedTitle = replaceAllSpecialCharacters(cleanedTitle)
        
        // replaceAll spaces with -
        cleanedTitle = replaceAllCharactersWithHyphen(cleanedTitle)
        
        // Ensure that the cleaned title does not end with - character
        if (cleanedTitle.endsWith('-')) {
          cleanedTitle = cleanedTitle.slice(0, -1)
        }

        cleanedTitle = removeMultipliedCharacters(cleanedTitle)
      
        // Ensure the total length does not exceed 920 characters
        cleanedTitle = cleanedTitle.slice(0, 920)
      
        // Clean category and subcategory names
        let cleanedCategory = cleanName(categoryName)

        let cleanedSubcategory = "";
        if (subcategoryName) {
            cleanedSubcategory = cleanName(subcategoryName)
            // Concatenate the category_name, subcategory_name, and cleanedTitle
            return cleanedCategory + '/' + cleanedSubcategory + '/' + cleanedTitle
        }    
        
        // Concatenate the category_name, and cleanedTitle
        return cleanedCategory + '/' + cleanedTitle
    }
    return ""
}

/** Currently used for cleaning category and subcategory names, in order to display them in the url */
export function cleanName(initialName) {
    let cleanedName = initialName.toLowerCase()
    cleanedName = cleanedName.replaceAll(/_/g, '-')
    cleanedName = replaceAllSpecialCharacters(cleanedName)
    return replaceAllCharactersWithHyphen(cleanedName)
}

export const arraysEqual = (newArray, oldArray) => {
    if (newArray == null && oldArray == null) return true
    if ((newArray == null && oldArray != null) || (newArray != null && oldArray == null)) return false
    if (newArray.length !== oldArray.length) return false
    for (let i = 0; i < newArray.length; i++) {
        if (newArray[i] !== oldArray[i]) return false
    }
    return true
}